import * as types from './mutation-types'

export default {
  [types.SET_VIDEO_COMMENT] (state, payload) {
    state.comment = payload
  },
  [types.SET_VIDEO_COMMENTS] (state, payload) {
    state.comments = payload.data
    state.pagination = payload.meta.pagination
  }
}
